import apiSlice from './apiSlice';
export type GetBetStatsParams = {
  fromDate?: string;
  toDate?: string;
  sport?: string| undefined;
  webhookName?: string;
};

export interface BetStats {
  totalBets: number;
  pendingBets: number;
  settledBets: number;
  rollbackedBets: number;
}

export interface GetBetStatsResponse {
  success: boolean;
  message: string;
  stats: BetStats;
}

export const statsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBetStats: builder.query<GetBetStatsResponse, GetBetStatsParams>({
      query: (params) => ({
        url: '/bets/stats',
        method: 'GET',
        params, // THIS is what you were missing
      }),
      providesTags: ['Stats'],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetBetStatsQuery, useLazyGetBetStatsQuery } = statsApi;